export default __webpack_public_path__ + "static/media/upIcon_B.3e243c5a.svg";